// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"438":"thankyou","636":"landing","884":"admin","973":"quiz-flow"}[chunkId] || chunkId) + "." + {"109":"165ef242","438":"045ae90f","614":"53baa244","636":"139e3296","730":"2948f358","884":"03cc400f","973":"94fa5ca0"}[chunkId] + ".chunk.js";
};